import React from 'react'

function StatusBadge({ status }) {
  const getStatusClass = (status) => {
    switch (status) {
      case 'ok':
        return 'badge badge-success'
      case 'failed':
        return 'badge badge-danger'
      case 'fallback':
        return 'badge badge-warning'
      default:
        return 'badge badge-secondary'
    }
  }

  const getStatusText = (status) => {
    switch (status) {
      case 'ok':
        return 'OK'
      case 'failed':
        return 'Failed'
      case 'fallback':
        return 'Fallback (from S3)'
      default:
        return status || 'Unknown'
    }
  }

  return (
    <span className={getStatusClass(status)}>
      {getStatusText(status)}
    </span>
  )
}

function MetadataInfo({ metadata, building, downloadUrl }) {
  if (!metadata || !metadata.key) {
    return (
      <div className="alert alert-warning">
        <h5>No Metadata Found</h5>
        <p>No property metadata is currently available in Redis or S3. This could mean:</p>
        <ul>
          <li>No metadata has been processed yet</li>
          <li>All metadata files have been marked as failed</li>
          <li>There's an issue with the S3 connection</li>
        </ul>
      </div>
    )
  }

  return (
    <div className="card">
      <div className="card-header">
        <h5>Current Metadata Information</h5>
      </div>
      <div className="card-body">
        <table className="table table-striped">
          <tbody>
            <tr>
              <th scope="row" style={{ width: '150px' }}>Key</th>
              <td>{metadata.key}</td>
            </tr>
            <tr>
              <th scope="row">Version ID</th>
              <td>
                {metadata.version_id ? (
                  <code>{metadata.version_id}</code>
                ) : (
                  <span className="text-muted">Not available</span>
                )}
              </td>
            </tr>
            <tr>
              <th scope="row">Status</th>
              <td>
                <StatusBadge status={metadata.status} />
              </td>
            </tr>
            <tr>
              <th scope="row">Checksum</th>
              <td>
                {metadata.checksum ? (
                  <code>{metadata.checksum}</code>
                ) : (
                  <span className="text-muted">Not available</span>
                )}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="mt-3">
          {metadata.version_id ? (
            <a href={downloadUrl} className="btn btn-primary">
              <i className="fa fa-download" aria-hidden="true"></i>
              Download Current Metadata File
            </a>
          ) : (
            <button className="btn btn-secondary" disabled>
              <i className="fa fa-download" aria-hidden="true"></i>
              Download Not Available
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

function MetadataDocumentation() {
  return (
    <div className="mt-4">
      <h5>About Property Metadata</h5>
      <p className="text-muted">
        This page shows the current status of the property metadata file that's being used by the system. 
        The metadata contains building structure and unit information that's used for various features throughout the application.
      </p>
      
      <div className="alert alert-info">
        <strong>Status Meanings:</strong>
        <ul className="mb-0 mt-2">
          <li><strong>OK:</strong> File has been validated and is ready for use</li>
          <li><strong>Failed:</strong> File failed validation and cannot be used</li>
          <li><strong>Fallback:</strong> Retrieved from S3 as fallback when Redis data is unavailable</li>
        </ul>
      </div>
    </div>
  )
}

export function MetadataStatus({ building, metadata, editDataUrl, downloadUrl }) {
  return (
    <div className="container">
      <a className="page-back btn btn-warning" href={editDataUrl}>
        <i className="fa fa-angle-left" aria-hidden="true"></i>
        Back to Edit Data
      </a>

      <h4 className="edit-container-header" style={{ marginBottom: '17px' }}>
        Property Metadata Status
      </h4>

      <MetadataInfo 
        metadata={metadata} 
        building={building} 
        downloadUrl={downloadUrl}
      />
      
      <MetadataDocumentation />
    </div>
  )
}
